/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nuget-viewer.ui-modal-dialog .mat-dialog-container{height:calc(100vh - 24px)!important;border-radius:8px!important;margin:12px!important}.nuget-viewer-container{height:100%;width:100%}"];
export { styles as styles };
